import { MediaType } from './MediaType.ts';
import type { ResolverContext } from './resolver-context.ts';
import { throwErrorWithResponse } from './throwErrorWithResponse.ts';

type Network = ResolverContext['network'];

export const fetchJSON = (
	{ cfetch }: Network,
	resource: string,
	init: Parameters<Network['cfetch']>[1],
) =>
	cfetch(resource, {
		...init,
		headers: {
			Accept: MediaType.JSON,
			...init?.headers,
		},
	}).then((response) => response.json().catch((error) => throwErrorWithResponse(error, response)));
